<nav
  *ngIf="tenant$ | async as tenant"
  class="navbar navbar-default"
  id="navbar-new"
>
  <!-- Brand and toggle get grouped for better mobile display -->
  <div class="navbar-header">
    <button
      type="button"
      class="navbar-toggle btn-lg"
      [attr.aria-expanded]="!isCollapsed"
      (click)="onToggle()"
    >
      <span class="sr-only" i18n="@@navbar-btn-toggleNavigation"
        >Toggle navigation</span
      >
      <i class="fas fa-bars" aria-hidden="true"></i>
    </button>
    <a class="navbar-brand" [href]="generateClassicUrl()" target="_top">{{
      tenantName
    }}</a>
  </div>

  <!-- Collect the nav links, forms, and other content for toggling -->
  <div class="navbar-collapse" [collapse]="isCollapsed">
    <ul class="nav navbar-nav">
      <li class="qa-home-btn">
        <a [href]="generateClassicUrl()" target="_top" i18n="@@navbar-link-home"
          >Home</a
        >
      </li>
      <li class="qa-lists-btn">
        <a
          [href]="generateClassicUrl('/mylists')"
          target="_top"
          i18n="@@navbar-link-myLists"
          >My Lists</a
        >
      </li>
      <li class="qa-bookmarks-btn">
        <a
          [href]="generateClassicUrl('/mybookmarks')"
          target="_top"
          i18n="@@navbar-link-myBookmarks"
          >My Bookmarks</a
        >
      </li>
      <li *ngIf="permissions.globals.VIEW_ACQUISITIONS" class="qa-reviews-btn">
        <a [href]="reviewsUrl" target="_top" i18n="@@navbar-link-reviews"
          >Reviews</a
        >
      </li>
      <!-- Update title param once list data is accessible -->
      <li class="qa-feedback-btn">
        <a
          [href]="generateClassicUrl('/feedback')"
          target="_top"
          i18n="@@navbar-link-feedback"
          >Feedback</a
        >
      </li>
      <li *ngIf="showAdminMenu()" dropdown class="qa-admin-btn btn-group">
        <button
          dropdownToggle
          class="qa-admin-dropdown-toggle navbar-btn btn-link"
          type="button"
        >
          <span i18n="@@navbar-adminMenu-btn-admin">Admin</span>
          <i class="caret" aria-hidden="true"></i>
        </button>
        <ul *dropdownMenu class="dropdown-menu">
          <li
            *ngIf="permissions.globals.RESOURCE_METADATA_REFRESH"
            class="qa-metadata-btn"
          >
            <a
              [href]="generateClassicUrl('/admin/resourcemetadatarefresh.html')"
              target="_top"
              i18n="@@navbar-adminMenu-link-metadataRefresh"
              >Book Metadata Refresh</a
            >
          </li>
          <li
            *ngIf="permissions.globals.ADMIN_BRANDING"
            class="qa-branding-btn"
          >
            <a
              [href]="generateClassicUrl('/admin/branding.html')"
              target="_top"
              i18n="@@navbar-adminMenu-link-branding"
              >Branding</a
            >
          </li>
          <li *ngIf="permissions.globals.ADMIN_BRANDING" class="qa-assets-btn">
            <a
              [href]="generateClassicUrl('/admin/assets.html')"
              target="_top"
              i18n="@@navbar-adminMenu-link-brandingAssets"
              >Branding Assets</a
            >
          </li>
          <li
            *ngIf="permissions.globals.HOME_MESSAGE"
            class="qa-home-message-btn"
          >
            <a
              [href]="generateClassicUrl('/admin/homepage.html')"
              target="_top"
              i18n="@@navbar-adminMenu-link-homepageMessage"
              >Homepage Message</a
            >
          </li>
          <li
            *ngIf="permissions.globals.UPLOAD_HIERARCHY"
            class="qa-hierarchy-btn"
          >
            <a
              [href]="generateClassicUrl('/admin/hierarchy.html')"
              target="_top"
              i18n="@@navbar-adminMenu-link-hiearchyUpload"
              >Hierarchy Upload</a
            >
          </li>
          <li *ngIf="permissions.globals.IDP_MIGRATION" class="qa-idp-btn">
            <a
              [href]="generateClassicUrl('/admin/idpmigration.html')"
              target="_top"
              i18n="@@navbar-adminMenu-link-idpMigration"
              >IDP Migration</a
            >
          </li>
          <li *ngIf="permissions.globals.ACCESS_KEYS" class="qa-access-btn">
            <a
              [href]="generateClassicUrl('/admin/access-keys.html')"
              target="_top"
              i18n="@@navbar-adminMenu-link-integrations"
              >Integrations</a
            >
          </li>
          <li
            *ngIf="permissions.globals.REQUEST_ROLLOVER"
            class="qa-rollover-btn"
          >
            <a
              [href]="generateClassicUrl('/admin/rollover.html')"
              target="_top"
              i18n="@@navbar-adminMenu-link-timePeriodRollover"
              >Request Time Period Rollover</a
            >
          </li>
          <li *ngIf="canReviewJobs()" class="qa-jobs-btn">
            <a
              [href]="generateClassicUrl('/jobs.html')"
              target="_top"
              i18n="@@navbar-adminMenu-link-reviewJobs"
              >Review Jobs</a
            >
          </li>
          <li *ngIf="permissions.globals.GRANT_ANY_ROLE" class="qa-invites-btn">
            <a
              [href]="generateClassicUrl('/roles.html')"
              target="_top"
              i18n="@@navbar-adminMenu-link-rolesAndInvites"
              >Roles & Invites</a
            >
          </li>
          <li
            *ngIf="permissions.globals.ADVANCED_MIS"
            class="qa-advanced-mis-btn"
          >
            <a
              [href]="generateClassicUrl('/admin/advanced-mis.html')"
              target="_top"
              i18n="@@navbar-adminMenu-link-advancedMIS"
              >Advanced MIS</a
            >
          </li>
        </ul>
      </li>
      <li
        *ngIf="
          (permissions.globals.VIEW_REPORTS && tenant?.reports?.length > 0) ||
          showMisDashboardLink()
        "
        dropdown
        class="qa-reports-btn btn-group"
      >
        <button
          dropdownToggle
          class="qa-reports-dropdown-toggle navbar-btn btn-link"
          type="button"
        >
          <span i18n="@@navbar-reportsMenu-btn-reports">Reports</span>
          <i class="caret" aria-hidden="true"></i>
        </button>
        <ul *dropdownMenu class="dropdown-menu">
          <li
            *ngIf="showMisDashboardLink()"
            class="qa-management-information-btn"
          >
            <a
              [href]="
                generateClassicUrl('/reports/management-information.html')
              "
              target="_top"
              i18n="@@navbar-reportsMenu-link-managementInformation"
              >Management Information</a
            >
          </li>
          <ng-container *ngIf="permissions.globals.VIEW_REPORTS">
            <li
              *ngIf="showMisDashboardLink()"
              class="divider"
              role="presentation"
            ></li>
            <li *ngFor="let report of tenant.reports">
              <a target="_top" [href]="report.id">
                {{ report.description }}
              </a>
            </li>
          </ng-container>
        </ul>
      </li>

      <ng-container [ngSwitch]="user?.isAnonymous">
        <ng-container *ngSwitchCase="false">
          <li dropdown class="qa-profile-btn">
            <button
              id="profile-menu"
              dropdownToggle
              aria-haspopup="true"
              class="qa-profile-dropdown-toggle navbar-btn btn-link"
              type="button"
            >
              <ng-container [ngSwitch]="user.profile ? true : false">
                <span *ngSwitchCase="false" i18n="@@navbar-btn-createProfile"
                  >Create a Profile</span
                >
                <ng-container *ngSwitchDefault>
                  <span>{{ user?.fullName }}</span>
                  <rl-avatar
                    *ngIf="user?.guid"
                    [user]="user.guid"
                    [size]="20"
                  ></rl-avatar>
                </ng-container>
              </ng-container>
              <i class="caret" aria-hidden="true"></i>
            </button>
            <ul
              *dropdownMenu
              class="dropdown-menu"
              aria-labelledby="profile-menu"
            >
              <ng-container [ngSwitch]="user.profile ? true : false">
                <li *ngSwitchCase="false">
                  <a
                    target="_top"
                    i18n="@@navbar-link-createProfile"
                    [href]="generateClassicUrl('/myprofile?create')"
                  >
                    Create a Profile
                  </a>
                </li>
                <li *ngSwitchDefault class="qa-view-profile-btn">
                  <a
                    target="_top"
                    i18n="@@navbar-link-viewProfile"
                    [href]="generateClassicUrl('/myprofile')"
                  >
                    View Profile
                  </a>
                </li>
              </ng-container>

              <li>
                <a
                  class="qa-logout-btn"
                  i18n="@@navbar-btn-logOut"
                  (click)="logout()"
                >
                  Log Out
                </a>
              </li>
            </ul>
          </li>
        </ng-container>

        <li *ngSwitchCase="true">
          <a (click)="login()" class="qa-login-btn" i18n="@@navbar-btn-logIn"
            >Log In</a
          >
        </li>
      </ng-container>

      <li
        *ngIf="tenant?.languages?.length > 1"
        dropdown
        class="qa-lang-btn btn-group"
      >
        <button
          dropdownToggle
          class="qa-lang-dropdown-toggle navbar-btn btn-link"
          type="button"
        >
          <i class="fas fa-globe-americas"
            ><span class="sr-only" i18n="@@navbar-btn-chooseLanguage"
              >Choose language</span
            ></i
          >
        </button>
        <ul *dropdownMenu class="dropdown-menu">
          <li
            *ngFor="let language of tenant.languages"
            [class.disabled]="locale === language.id"
          >
            <a
              target="_top"
              [attr.href]="
                locale === language.id
                  ? null
                  : generateSwitchLanguageUrl(language.id)
              "
              [lang]="language.id"
            >
              {{ language.label }}
            </a>
          </li>
        </ul>
      </li>

      <li>
        <a
          class="qa-accessibility-link"
          href="https://talis.com/accessibility"
          target="_blank"
        >
          <span class="sr-only" i18n="@@navbar-link-accessibility">
            Accessibility
          </span>
          <i class="fal fa-universal-access" aria-hidden="true"></i>
        </a>
      </li>
    </ul>
  </div>
  <!-- /.navbar-collapse -->
</nav>
